import { GetUserAccountAccessModelDto as BoGetUserAccountAccessModelDto } from '@treasury/api/bo';
import { GetUserAccountAccessModelDto as ConsumerGetUserAccountAccessModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { AccountAccess } from './account-access.entity';

const defaultCompanyUserAccountAccess: BoGetUserAccountAccessModelDto = {
    accounts: [],
};

export class CompanyUserAccountAccess extends DomainEntity<
    BoGetUserAccountAccessModelDto | ConsumerGetUserAccountAccessModelDto
> {
    constructor(dto: BoGetUserAccountAccessModelDto | ConsumerGetUserAccountAccessModelDto) {
        super(dto);
        this.accounts = dto.accounts?.map(account => new AccountAccess(account)) ?? [];
    }

    public accounts: AccountAccess[] = [];

    public createDefault(): this {
        return new CompanyUserAccountAccess(defaultCompanyUserAccountAccess) as this;
    }
}
